import { useEffect } from 'react'

export function useCommandShortcut(enabled: boolean, open: () => void) {
  useEffect(() => {
    if (!enabled) return
    const handle = (event: KeyboardEvent) => {
      if (event.defaultPrevented || event.isComposing || event.repeat || event.altKey || event.shiftKey
        || !(event.ctrlKey || event.metaKey) || event.key.toLowerCase() !== 'k') return
      const target = event.target instanceof Element ? event.target : null
      if (target?.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="textbox"], [role="combobox"], [data-shortcuts="off"]')
        || document.querySelector('dialog[open], [role="dialog"][aria-modal="true"], [role="alertdialog"]')) return
      event.preventDefault()
      open()
    }
    document.addEventListener('keydown', handle)
    return () => document.removeEventListener('keydown', handle)
  }, [enabled, open])
}
